import { protectedResources } from '@/authConfig';
import acquireAccessToken from '@/http/Helpers/acquireAccessToken';
import { applyPlaygroundModeHeader } from '@/http/Helpers/playgroundModeHeader';
import {
  handleApiResponse,
  rememberRequestBody
} from '@/http/OpenAPI/clients/staleClaimRetry';
import * as Sentry from '@sentry/browser';
import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';

import type { paths } from '../../types/company';

const { logger } = Sentry;

const scopes = protectedResources.companyApi.scopes;

const fetchClient = createFetchClient<paths>({
  baseUrl: protectedResources.companyApi.endpoint
});

fetchClient.use({
  onRequest: async (req) => {
    try {
      const token = await acquireAccessToken(scopes);
      req.request.headers.set('Authorization', `Bearer ${token}`);
      applyPlaygroundModeHeader(req.request);
      // Buffer the body while it is still readable — a 403 replay cannot clone a Request
      // that fetch has already consumed (ADO #7699).
      await rememberRequestBody(req.request);
    } catch {
      // Do nothing
    }
  },
  onResponse: (ctx) => handleApiResponse(ctx, { api: 'company', scopes }),
  onError: async (err) => {
    logger.error('Error occurred in company fetch client', {
      error: err,
      api: 'company'
    });
  }
});

export const $companyApi = createClient(fetchClient);
